import React, { useCallback } from 'react';

const openUrlInChrome = (url: string) => {
  window.open(url, '_blank');
};

const ToteReportingAction = () => {
  const iframeUrl = 'http://ec2-35-161-89-228.us-west-2.compute.amazonaws.com/';

  const handleClick = useCallback(() => {
    openUrlInChrome(iframeUrl);
  }, []);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>) => {
    if (event.key === 'Enter') {
      handleClick();
    }
  };

  return (
    <button
      style={{
        right: 15,
        left: 'auto',
        float: 'right',
        marginLeft: '10px',
        backgroundColor: 'grey',
        color: 'white',
        padding: '10px 20px',
        borderRadius: '5px',
        cursor: 'pointer',
      }}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      <span>Reporting</span>
    </button>
  );
};

export default ToteReportingAction;
